import React, { useLayoutEffect, useRef, useState } from 'react';
import { Highlighter } from '../../lib/paper';
import { ScanPrint } from './ScanPrint';

/**
 * The note's summary on a yellow sticky — the "what is this page?" answer before
 * the transcription (mobile's GistSticky). Clamped to four lines with Read more;
 * the scan print pokes over the top-right corner.
 */
export const GistSticky: React.FC<{
  summary: string | null;
  scanSrc: string;
  tone: Highlighter;
  lifted: boolean;
  onOpenScan: (rect: DOMRect | null) => void;
}> = ({ summary, scanSrc, tone, lifted, onOpenScan }) => {
  const [open, setOpen] = useState(false);
  const [overflows, setOverflows] = useState(false);
  const text = useRef<HTMLParagraphElement>(null);

  useLayoutEffect(() => {
    const el = text.current;
    if (el && !open) setOverflows(el.scrollHeight > el.clientHeight + 1);
  }, [summary, open]);

  return (
    <div className="relative rotate-[0.6deg] rounded-lg rounded-br-[1.75rem] border border-solid border-[rgba(107,82,0,0.18)] bg-hl-yellow p-4 pt-3.5 shadow-[0_12px_40px_rgba(28,27,25,0.1)] md:p-5">
      <p className="m-0 pr-20 font-headline text-[1.1875rem] italic leading-7 text-hl-yellow-ink">
        {summary ? 'The gist' : 'Your original page'}
      </p>
      <div className="absolute right-4 top-[-30px]">
        <ScanPrint src={scanSrc} tone={tone} width={44} tilt={4} lifted={lifted} onOpen={onOpenScan} />
      </div>
      <p
        ref={text}
        className={`m-0 mt-1 font-body text-[0.984rem] leading-[1.55] text-on-surface ${open ? '' : 'line-clamp-4'}`}
      >
        {summary ?? 'Click the print to zoom in on your handwriting.'}
      </p>
      {(overflows || open) && (
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="mt-1.5 cursor-pointer border-none bg-transparent p-0 font-body text-[0.8125rem] font-semibold text-hl-yellow-ink hover:underline"
        >
          {open ? 'Show less' : 'Read more'}
        </button>
      )}
    </div>
  );
};
